import styled from "styled-components";

export const InputGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;

  *:not(:nth-child(-n + 2)) {
    grid-column: 1/-1;
  }
`;
